export const INACTIVITY_CONFIG = {
    debug: false,
    detectionDelay: 10000, // 10 second(s)
    notifyAfter: [
        1 * ( 1000 * 60 ), // 1 minute(s)
        5 * ( 1000 * 60 ), // 5 minute(s)
        30 * ( 1000 * 60 ), // 30 minute(s)
    ],
};
